import { render, staticRenderFns } from "./MusicElement.vue?vue&type=template&id=2145171a&scoped=true&"
import script from "./MusicElement.vue?vue&type=script&lang=js&"
export * from "./MusicElement.vue?vue&type=script&lang=js&"
import style0 from "./MusicElement.vue?vue&type=style&index=0&id=2145171a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145171a",
  null
  
)

export default component.exports